import { datajs, datajsAll } from '../shared/utils';
import Swiper, { Pagination } from 'swiper';
import { Modal } from 'bootstrap';

export default class FiftyFiftyBlock {
	static init() {
		const sliders = datajsAll('fiftyfifty-slider');

		sliders.forEach((slider) => {
			const totalSlides = slider.dataset.totalSlides || 1;

			if (totalSlides > 1) {
				this.sliderConfig(slider);
			}

			this.videoModal(slider);
		});
	}

	// Setup Slider
	static sliderConfig(slider) {
		const sliderWrapper = slider.closest('[data-js~=fiftyfifty]');

		// eslint-disable-next-line no-new
		new Swiper(slider, {
			modules: [Pagination],
			loop: true,
			slidesPerView: 1,
			speed: 500,
			spaceBetween: 0,

			pagination: {
				el: datajs('fiftyfifty-pagination', sliderWrapper),
				bulletClass: 'm-sliderPagination__item',
				bulletActiveClass: 'is-active',
				clickable: true,
			},
		});
	}

	// Setup Modal
	static videoModal(slider) {
		const buttons = datajsAll('video-slide-play-button', slider);
		const sliderWrapper = slider.closest('[data-js~=fiftyfifty]');
		const sliderModalElement = datajs('video-modal', sliderWrapper);
		const sliderModalElementContent = datajs('video-modal-content', sliderWrapper);
		const sliderModal = new Modal(sliderModalElement);

		// Show modal event
		sliderModalElement.addEventListener('shown.bs.modal', function () {
			const videoElement = sliderModalElementContent.querySelector('video');
			const iframe = sliderModalElementContent.querySelector('iframe');

			if (videoElement) {
				videoElement.play();
			} else if (iframe) {
				iframe.setAttribute('src', iframe.dataset.src + '&autoplay=1');
			}
		});

		// Hide modal event
		sliderModalElement.addEventListener('hidden.bs.modal', function () {
			const videoElement = sliderModalElementContent.querySelector('video');
			const iframe = sliderModalElementContent.querySelector('iframe');

			if (videoElement) {
				videoElement.pause();
			} else if (iframe) {
				iframe.removeAttribute('src');
			}
		});

		buttons.forEach((button) => {
			const currentVideoSlide = button.closest('[data-js~=video-slide]');
			const currentVideoElement = datajs('video-slide-video', currentVideoSlide);

			button.addEventListener('click', function (e) {
				e.preventDefault();
				sliderModalElementContent.innerHTML = currentVideoElement.innerHTML;
				sliderModal.show();
			});
		});
	}
}
